// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"12068848955f87754144","532":"716a0d5d7b4b07d02948","691":"4e15221cdd78567cfd3f"}[chunkId] + ".js";
};